exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button{min-width:120px!important}.header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}.note{-ms-flex-line-pack:center;align-content:center;padding-right:16px}.wz_data_table td{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;max-width:200px!important}.wz_data_table{border-top-right-radius:0;border-top-left-radius:0;height:calc(100% - 68px)}.wz_table_header{background-color:#edf3fb;color:#424242;height:68px}", ""]);

// exports
